import $ from 'jquery'
import { setCookie, unsetCookie, getCookie } from 'rytm-helpers'


export const initWcag = () => {
  $('body').on('click', '.font-size', onFontSizeClick)
  $('body').on('click', '.toggle-contrast', onToggleContrast)
}

const onToggleContrast = (e) => {
  e.preventDefault();
  let cont = document.documentElement.classList.contains('wcag-contrast') ? 0 : 1
  setCookie("umediateka_wcag_contrast", cont, 1)
  // if (cont == 1) {
  //   document.documentElement.classList.add('wcag-contrast')
  // } else {
  //   document.documentElement.classList.remove('wcag-contrast')
  // }
  // refresh
  location.reload()
}
const onFontSizeClick = (e) => {
  e.preventDefault();
  const a = e.currentTarget
  const size = a ? a.dataset.size : 1
  setCookie("umediateka_wcag_font_size", size, 1)
  // document.documentElement.classList.remove('wcag-font-size-1')
  // document.documentElement.classList.remove('wcag-font-size-2')
  // document.documentElement.classList.remove('wcag-font-size-3')
  // document.documentElement.classList.add('wcag-font-size-' + size)
  // refresh
  location.reload()
}

